<template>
  <v-btn
    text
    class="document-card rounded overflow-hidden elevation-2 text-center cursor-pointer pa-0 bg-gray-0"
    data-qa="document_card"
    :data-qa-id="item.id"
    height="275"
    width="255"
    :ripple="false"
    @click="emit('open')"
  >
    <div class="document-card__body position-relative w-100 h-100">
      <div class="document-card__overlay position-relative w-100 h-100">
        <img
          class="document-card__image d-block w-100"
          :src="item.previewSrc"
          :alt="item.alt || item.title || ''"
          :title="item.title || ''"
          loading="lazy"
        >
        <div
          class="document-card__overlay-gradient position-absolute top-0 left-0 w-100 h-100"
          aria-hidden="true"
        />
      </div>
      <div class="document-card__label position-absolute w-100 text-body-2 text-secondary--text px-4">
        {{ item.title }}
        <div class="document-card__show-more primary--text mt-2 d-none">
          {{ t('посмотреть', options) }}
        </div>
      </div>
    </div>
  </v-btn>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import type { DocumentItem } from 'src/components/pages/info/document/index/types'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  item: DocumentItem
}>()

type Emits = {
  (_event: 'open'): void
}

const emit = defineEmits<Emits>()
</script>

<style scoped lang="scss">
@import 'src/styles/variables';

.document-card {
  min-width: 255px;
  max-width: 255px;
  border: 0;
  transition: box-shadow 0.2s ease;

  :deep(.v-btn__content) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    white-space: normal;
  }

  &:hover {
    @include elevation-8;

    .document-card__show-more {
      display: block !important;
    }
  }

  &__overlay-gradient {
    pointer-events: none;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 50%, #FFFFFF 70%);
  }

  &__label {
    bottom: 16px;
    left: 0;
  }
}
</style>
